<template>
    <svg
        width="187"
        height="196"
        viewBox="0 0 187 196"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M89.711 54.8454C87.5526 52.2877 83.197 50.9517 79.9826 51.8615L4.10325 73.3372C0.888788 74.247 0.0326861 77.058 2.19109 79.6157L97.289 192.307C99.4474 194.864 103.803 196.2 107.017 195.29L182.897 173.815C186.111 172.905 186.967 170.094 184.809 167.536L89.711 54.8454Z"
            fill="black"
            fill-opacity="0.1"
        />
        <path
            d="M88.6789 38.0026C87.0749 36.1042 83.8382 35.1126 81.4494 35.7879L6.91501e-07 52.2455C6.90572e-07 53.4842 1.71701e-06 58.4391 1.71701e-06 58.4391C1.71701e-06 58.4391 -2.62154e-08 60.0157 2.99326e-10 60.9165C0.0538185 61.5333 0.339667 62.1888 0.875752 62.8233L98.3145 178.149C99.9185 180.048 103.155 181.039 105.544 180.364L184.697 157.989C187.085 157.313 187 155.51 187 153.596V147.289L186.118 145.6L88.6789 38.0026Z"
            fill="#52525B"
        />
        <path
            d="M88.6825 30.0026C87.0787 28.1042 83.8421 27.1126 81.4535 27.7879L2.30599 50.1631C-0.0826387 50.8384 -0.718802 52.9248 0.885085 54.8233L98.3175 170.149C99.9213 172.048 103.158 173.039 105.547 172.364L184.694 149.989C187.083 149.313 187.719 147.227 186.115 145.329L88.6825 30.0026Z"
            fill="#A1A1AA"
        />
        <path
            d="M86.9292 35.6403C85.5664 34.0253 82.8163 33.1818 80.7867 33.7562L10.9594 53.5192C8.92978 54.0937 8.38924 55.8685 9.75206 57.4834L100.071 164.512C101.434 166.127 104.184 166.97 106.213 166.396L176.041 146.633C178.07 146.058 178.611 144.283 177.248 142.668L86.9292 35.6403Z"
            fill="#E4E4E7"
        />
        <mask
            id="mask0_8525_47937"
            style="mask-type: alpha"
            maskUnits="userSpaceOnUse"
            x="8"
            y="33"
            width="171"
            height="134"
        >
            <path
                d="M86.9821 35.6568C85.6161 34.0434 82.8596 33.2008 80.8252 33.7746L10.8352 53.5183C8.80083 54.0922 8.25902 55.8653 9.62502 57.4787L100.154 164.403C101.52 166.016 104.277 166.859 106.311 166.285L176.301 146.541C178.336 145.967 178.877 144.194 177.511 142.581L86.9821 35.6568Z"
                fill="#A1A1AA"
            />
        </mask>
        <g mask="url(#mask0_8525_47937)">
            <rect
                width="82.677"
                height="155.183"
                transform="matrix(0.962455 -0.27144 0.646257 0.76312 4.25771 52.0901)"
                fill="#BEF263"
            />
            <path
                d="M44.5959 81.7956C44.7468 78.9954 45.1026 76.2217 44.7251 73.3304C44.2623 69.7854 42.9275 66.192 41.9521 62.6187C41.3049 60.2479 39.8293 55.9769 42.2077 54.3029C43.9463 53.0791 46.5873 52.46 48.9072 51.8057C53.597 50.483 58.189 48.9696 62.6548 47.4C65.9198 46.2525 65.863 43.9762 67.0944 41.8014C67.4208 41.2249 68.8227 40.3894 68.7143 39.7989"
                stroke="#F7FEE7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M94.252 122.723C87.9684 119.557 81.192 117.519 74.4705 115.184C72.5266 114.508 70.8877 113.666 69.0268 112.848C62.7145 110.073 55.5622 106.474 51.0884 102.133C50.0256 101.102 48.9096 99.3609 49.2829 98.3089C49.5699 97.5003 50.6882 97.2307 50.7817 96.3405C50.8297 95.8839 51.4912 95.7697 51.6212 95.4035C51.9043 94.6057 51.4073 93.3755 51.2792 92.501C51.0651 91.039 50.7516 89.7727 49.5665 88.3733C48.808 87.4776 47.8855 86.7113 46.7803 85.9884C46.0377 85.5026 45.5191 85.2153 45.8355 84.6563C46.366 83.7195 46.8997 83.4535 45.9724 82.3586"
                stroke="#F7FEE7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M99.4862 69.4063C103.827 68.798 107.253 67.1494 111.214 66.0986C114.252 65.2927 118.127 65.6273 121.693 66.2346"
                stroke="#F7FEE7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M96.2787 124.054C99.1009 125.047 101.694 126.691 104.03 128.249C108.923 131.512 113.309 135.196 117.806 138.711C121.467 141.573 127.109 147.766 132.894 147.733C137.07 147.71 139.16 145.784 142.32 144.599C144.022 143.961 145.361 143.114 146.748 142.214C149.242 140.596 152.285 139.321 155.33 138.182C159.051 136.79 163.409 135.591 168.447 137.045C170.714 137.699 172.888 138.788 175.109 139.579C177.364 140.383 179.54 141.288 181.677 142.298C183.388 143.107 184.969 143.984 186.605 144.832C187.588 145.342 187.959 145.413 189.073 145.444"
                stroke="#F7FEE7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M64.6363 32.1503C73.9517 42.9168 83.4087 53.6598 93.5972 64.1445C99.0669 69.7732 106.559 75.8017 109.825 82.0667C112.087 86.4086 113.812 91.6127 112.014 95.4928C110.401 98.9721 107.782 101.944 105.11 104.931C100.595 109.976 97.1434 115.287 95.4671 121.482C93.9185 127.206 93.3797 133.149 93.3631 139.224C93.3569 141.473 92.631 143.973 93.7257 146.361C95.3748 149.958 99.8528 153.196 102.4 156.624C105.713 161.082 108.635 165.561 112.342 169.938C114.126 172.045 115.872 174.118 118.257 175.998C119.285 176.808 120.424 177.533 121.8 177.998C124.002 178.742 125.301 178.45 127.252 178.336"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                d="M25.1829 77.9963C51.4618 82.789 78.583 87.8635 102.586 100.081C111.722 104.73 120.424 109.996 127.469 116.262C134.149 122.201 138.438 128.859 143.823 135.218C148.697 140.973 153.039 146.92 160.093 151.794C166.718 156.372 176.205 159.297 184.294 159.633"
                stroke="white"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M92.1033 83.7806C90.2008 83.2583 88.396 82.2155 87.2157 80.8218C85.0333 78.2448 85.8089 75.4378 88.9478 74.5525C92.0867 73.6673 96.4009 75.0388 98.5833 77.6158C99.7353 78.9762 100.062 80.4007 99.6555 81.5711L98.701 86.0694L92.1033 83.7806Z"
                fill="#FBBD23"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M95.2256 82.3818C95.2099 82.3862 95.1921 82.388 95.1774 82.389C95.0831 82.3965 94.9747 82.3508 94.916 82.2815L93.2792 80.3487L92.0537 80.6944C91.988 80.7129 91.9047 80.7014 91.8343 80.664C91.7608 80.6275 91.713 80.571 91.7051 80.516L91.1335 76.9506C91.1219 76.8775 91.1803 76.8229 91.2768 76.8179C91.3711 76.8104 91.4796 76.8561 91.5382 76.9254L93.1728 78.8556L94.3984 78.51C94.464 78.4915 94.5473 78.5029 94.6177 78.5403C94.6912 78.5768 94.7391 78.6333 94.7469 78.6883L95.3186 82.2538C95.3308 82.3139 95.2943 82.3624 95.2256 82.3818Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M98.5655 143.548C96.663 143.025 94.8582 141.983 93.6779 140.589C91.4955 138.012 92.271 135.205 95.4099 134.32C98.5488 133.434 102.863 134.806 105.045 137.383C106.197 138.743 106.525 140.168 106.118 141.338L105.163 145.836L98.5655 143.548Z"
                fill="#FBBD23"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M101.688 142.149C101.672 142.153 101.654 142.155 101.64 142.156C101.545 142.164 101.437 142.118 101.378 142.049L99.7414 140.116L98.5159 140.461C98.4502 140.48 98.3669 140.468 98.2965 140.431C98.223 140.395 98.1752 140.338 98.1673 140.283L97.5956 136.718C97.5841 136.645 97.6425 136.59 97.739 136.585C97.8333 136.578 97.9417 136.623 98.0004 136.693L99.635 138.623L100.861 138.277C100.926 138.259 101.01 138.27 101.08 138.307C101.153 138.344 101.201 138.4 101.209 138.455L101.781 142.021C101.793 142.081 101.757 142.129 101.688 142.149Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M103.233 117.739C101.33 117.217 99.5253 116.174 98.345 114.781C96.1626 112.204 96.9382 109.397 100.077 108.511C103.216 107.626 107.53 108.998 109.713 111.575C110.865 112.935 111.192 114.359 110.785 115.53L109.83 120.028L103.233 117.739Z"
                fill="#0DA2E7"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M106.355 116.34C106.339 116.345 106.321 116.347 106.307 116.348C106.212 116.355 106.104 116.309 106.045 116.24L104.409 114.307L103.183 114.653C103.117 114.672 103.034 114.66 102.964 114.623C102.89 114.586 102.842 114.53 102.834 114.475L102.263 110.909C102.251 110.836 102.31 110.782 102.406 110.777C102.5 110.769 102.609 110.815 102.668 110.884L104.302 112.814L105.528 112.469C105.593 112.45 105.677 112.462 105.747 112.499C105.821 112.536 105.868 112.592 105.876 112.647L106.448 116.213C106.46 116.273 106.424 116.321 106.355 116.34Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M119.436 100.752C117.534 100.23 115.729 99.187 114.549 97.7933C112.366 95.2163 113.142 92.4092 116.281 91.524C119.419 90.6387 123.734 92.0103 125.916 94.5873C127.068 95.9476 127.395 97.3721 126.988 98.5426L126.034 103.041L119.436 100.752Z"
                fill="#2EE09F"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M122.558 99.3532C122.543 99.3576 122.525 99.3594 122.51 99.3604C122.416 99.3679 122.307 99.3222 122.249 99.2529L120.612 97.3202L119.386 97.6658C119.321 97.6843 119.238 97.6728 119.167 97.6354C119.094 97.5989 119.046 97.5425 119.038 97.4875L118.466 93.922C118.455 93.8489 118.513 93.7943 118.61 93.7894C118.704 93.7819 118.812 93.8276 118.871 93.8969L120.506 95.8271L121.731 95.4814C121.797 95.4629 121.88 95.4744 121.951 95.5118C122.024 95.5483 122.072 95.6047 122.08 95.6598L122.651 99.2252C122.664 99.2854 122.627 99.3338 122.558 99.3532Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M65.8496 104.042C63.9471 103.519 62.1423 102.477 60.962 101.083C58.7796 98.5058 59.5551 95.6988 62.694 94.8135C65.8329 93.9283 70.1472 95.2998 72.3295 97.8768C73.4816 99.2372 73.8087 100.662 73.4017 101.832L72.4472 106.33L65.8496 104.042Z"
                fill="#FB6F84"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M68.9718 102.643C68.9562 102.647 68.9384 102.649 68.9237 102.65C68.8294 102.657 68.7209 102.612 68.6623 102.542L67.0255 100.61L65.7999 100.955C65.7343 100.974 65.651 100.962 65.5806 100.925C65.5071 100.888 65.4592 100.832 65.4514 100.777L64.8797 97.2116C64.8682 97.1385 64.9265 97.0839 65.023 97.0789C65.1174 97.0714 65.2258 97.1171 65.2845 97.1864L66.9191 99.1166L68.1446 98.771C68.2103 98.7525 68.2936 98.7639 68.364 98.8013C68.4375 98.8378 68.4853 98.8943 68.4932 98.9493L69.0648 102.515C69.0771 102.575 69.0406 102.623 68.9718 102.643Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M55.5764 67.8001C53.6739 67.2778 51.8691 66.2351 50.6888 64.8413C48.5064 62.2644 49.2819 59.4573 52.4208 58.5721C55.5597 57.6868 59.874 59.0584 62.0563 61.6354C63.2084 62.9957 63.5355 64.4202 63.1285 65.5907L62.174 70.0889L55.5764 67.8001Z"
                fill="#2EE09F"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M58.6986 66.4013C58.683 66.4057 58.6652 66.4075 58.6505 66.4085C58.5562 66.416 58.4477 66.3703 58.3891 66.301L56.7523 64.3682L55.5267 64.7139C55.4611 64.7324 55.3778 64.7209 55.3074 64.6835C55.2339 64.647 55.1861 64.5906 55.1782 64.5356L54.6065 60.9701C54.595 60.897 54.6533 60.8424 54.7498 60.8375C54.8442 60.8299 54.9526 60.8757 55.0113 60.945L56.6459 62.8752L57.8714 62.5295C57.9371 62.511 58.0204 62.5225 58.0908 62.5599C58.1643 62.5964 58.2121 62.6528 58.22 62.7078L58.7916 66.2733C58.8039 66.3335 58.7674 66.3819 58.6986 66.4013Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M142.506 119.679C140.604 119.157 138.799 118.114 137.618 116.72C135.436 114.144 136.212 111.336 139.351 110.451C142.489 109.566 146.804 110.938 148.986 113.515C150.138 114.875 150.465 116.299 150.058 117.47L149.104 121.968L142.506 119.679Z"
                fill="#FBBD23"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M145.628 118.28C145.613 118.285 145.595 118.287 145.58 118.288C145.486 118.295 145.377 118.249 145.319 118.18L143.682 116.247L142.456 116.593C142.391 116.612 142.307 116.6 142.237 116.563C142.164 116.526 142.116 116.47 142.108 116.415L141.536 112.849C141.525 112.776 141.583 112.722 141.68 112.717C141.774 112.709 141.882 112.755 141.941 112.824L143.576 114.754L144.801 114.409C144.867 114.39 144.95 114.402 145.02 114.439C145.094 114.476 145.142 114.532 145.15 114.587L145.721 118.152C145.734 118.213 145.697 118.261 145.628 118.28Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M30.1487 71.0738C28.2462 70.5515 26.4414 69.5088 25.2611 68.115C23.0787 65.538 23.8542 62.731 26.9931 61.8457C30.132 60.9605 34.4463 62.3321 36.6286 64.909C37.7807 66.2694 38.1078 67.6939 37.7008 68.8643L36.7463 73.3626L30.1487 71.0738Z"
                fill="#FBBD23"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M33.2709 69.675C33.2553 69.6794 33.2375 69.6812 33.2228 69.6822C33.1285 69.6897 33.02 69.644 32.9613 69.5747L31.3246 67.6419L30.099 67.9876C30.0334 68.0061 29.9501 67.9946 29.8797 67.9572C29.8062 67.9207 29.7583 67.8643 29.7505 67.8092L29.1788 64.2438C29.1673 64.1707 29.2256 64.1161 29.3221 64.1112C29.4165 64.1036 29.5249 64.1494 29.5836 64.2187L31.2182 66.1488L32.4437 65.8032C32.5094 65.7847 32.5927 65.7962 32.6631 65.8335C32.7366 65.87 32.7844 65.9265 32.7923 65.9815L33.3639 69.547C33.3761 69.6071 33.3397 69.6556 33.2709 69.675Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M130.913 147.703C129.011 147.18 127.206 146.138 126.026 144.744C123.843 142.167 124.619 139.36 127.758 138.475C130.897 137.589 135.211 138.961 137.393 141.538C138.545 142.898 138.872 144.323 138.465 145.493L137.511 149.992L130.913 147.703Z"
                fill="#2EE09F"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M134.035 146.304C134.02 146.308 134.002 146.31 133.987 146.311C133.893 146.319 133.785 146.273 133.726 146.204L132.089 144.271L130.864 144.616C130.798 144.635 130.715 144.624 130.644 144.586C130.571 144.55 130.523 144.493 130.515 144.438L129.943 140.873C129.932 140.8 129.99 140.745 130.087 140.74C130.181 140.733 130.289 140.778 130.348 140.848L131.983 142.778L133.208 142.432C133.274 142.414 133.357 142.425 133.428 142.462C133.501 142.499 133.549 142.555 133.557 142.61L134.128 146.176C134.141 146.236 134.104 146.284 134.035 146.304Z"
                fill="white"
            />
        </g>
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M65.0788 47.8356C59.5134 42.8899 56 35.642 56 27.5772C56 12.6656 68.0164 0.575928 82.8377 0.575928C97.6589 0.575928 109.675 12.6656 109.675 27.5772C109.675 35.4489 106.324 42.5334 100.995 47.4643L82.8377 67.2178L65.0788 47.8356Z"
            fill="#0DA2E7"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M81.4945 45.4146C81.4207 45.4146 81.3469 45.3997 81.2878 45.3849C80.904 45.2958 80.6383 44.9393 80.6383 44.5383V33.3546H74.8515C74.5415 33.3546 74.2611 33.1912 74.1134 32.9239C73.9511 32.6566 73.951 32.3298 74.0987 32.0625L83.4284 14.6557C83.6203 14.2992 84.0189 14.121 84.4027 14.225C84.7865 14.3141 85.0522 14.6705 85.0522 15.0715V26.2404H90.839C91.149 26.2404 91.4295 26.4038 91.5771 26.6711C91.7395 26.9385 91.7395 27.2652 91.5919 27.5325L82.2622 44.9393C82.1145 45.2364 81.8193 45.4146 81.4945 45.4146Z"
            fill="white"
        />
    </svg>
</template>
